import axios from "axios";
import { Constants } from "../utils/Constants";

export const getDataTableExpert = (payload) => {
    return axios.post(`${Constants.baseUrl}/experts/list`, payload);
};

export const getChatList = () => {
    return axios.get(`${Constants.baseUrl}/experts`);
};

export const deleteExpertsChat = (id_chat) => {
    return axios.delete(`${Constants.baseUrl}/experts/${id_chat}`);
};

export const getChatMessages = (id_chat) => {
    return axios.get(`${Constants.baseUrl}/experts/${id_chat}`);
};

export const updateMessageMetadata = (id_mensagem, payload) => {
    return axios.post(`${Constants.baseUrl}/experts/metadata/${id_mensagem}`, payload);
};

export const sendMessageStream = async (id_chat, payload, token, onData, onFinish, onError) => {
    try {
        const response = await fetch(`${Constants.baseUrl}/experts/${id_chat ?? ""}`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: payload,
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        if (response.status !== 200) {
            const { value } = await reader.read();
            const chunk = decoder.decode(value);
            const error = JSON.parse(chunk);
            throw error.errors?.[0];
        }

        const contentType = response.headers.get("Content-Type");

        if (contentType.includes("application/json")) {
            onFinish(response.json());
        } else {
            let buffer = "";

            while (true) {
                const { done, value } = await reader.read();

                if (done) {
                    break;
                }

                const chunk = decoder.decode(value, { stream: true });
                buffer += chunk;
                const parts = buffer.split("\n\n");

                for (const eventBlock of parts) {
                    if (!eventBlock.trim()) continue;

                    const lines = eventBlock.split("\n");
                    let eventType = "message"; // default
                    let data = "";

                    for (const line of lines) {
                        if (line.startsWith("event:")) {
                            eventType = line.replace("event:", "").trim();
                        } else if (line.startsWith("data:")) {
                            data += line.replace("data:", "").trim();
                        }
                    }

                    try {
                        const { value } = JSON.parse(data);

                        if (eventType === "message") {
                            onData(value);
                        } else if (eventType === "end") {
                            onFinish(value);
                        } else if (eventType === "error") {
                            onError(value);
                        } else if (eventType === "image_generator") {
                            onData(value);
                        }
                    } catch (err) {
                        throw new Error("Erro ao ler resposta");
                    }
                }

                buffer = parts[parts.length - 1];
            }
        }
    } catch (err) {
        onError(err);
    }
};
